interface DateFormatOpt {
  year: 'numeric' | '2-digit';
  month: 'short';
}

const options: DateFormatOpt = {
  year: 'numeric',
  month: 'short',
};

export const parseDateForJobPeriod = (date: Date | 'now') => {
  if (date === 'now') return 'Now';

  return date.toLocaleDateString('en-US', options);
};
